import React from 'react'
import { Icon } from '../ui'
import { BreadCrumbCompenent } from '../ui/BreadCrumbCompenent'

interface Props {
  breadCrumb?: {
    readonly level: ReadonlyArray<{
      readonly levelNumber: number | null
      readonly label: string | null
      readonly slug: string | null
    } | null> | null
  } | null
  landingSlug?: string | null
  landingLabel?: string | null
}

export const BreadCrumbComponentList: React.FC<Props> = ({
  breadCrumb = { level: [] },
  landingSlug = '',
  landingLabel = '',
}) => (
  <nav className="flex my-5 text-night" aria-label="Breadcrumb">
    <ol className="flex flex-wrap items-center space-x-1 text-sm md:space-x-2 rtl:space-x-reverse lg:text-base">
      {breadCrumb?.level?.map((level) => (
        <BreadCrumbCompenent level={level} key={level?.slug} />
      ))}
      {!breadCrumb?.level && (
        <Icon icon="home" className="w-5 h-5 place-self-start" />
      )}
      {landingLabel && landingSlug && <li key={landingSlug}>{landingLabel}</li>}
    </ol>
  </nav>
)
